/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxMobile140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd">
            <ellipse cx={70} cy={136} fill={vars.bdlBoxBlue10} rx={46} ry={4} />
            <path fill={vars.white} d="M30 11h74a6 6 0 016 6v90a6 6 0 01-6 6H30a6 6 0 01-6-6V17a6 6 0 016-6z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M104 11a6 6 0 016 6v90a6 6 0 01-6 6H30a6 6 0 01-6-6V17a6 6 0 016-6h74zm0 2H30a4 4 0 00-3.995 3.8L26 17v90a4 4 0 003.8 3.995l.2.005h74a4 4 0 003.995-3.8l.005-.2V17a4 4 0 00-3.8-3.995L104 13z"
            />
            <path fill={vars.bdlBoxBlue05} d="M30 17h74v90H30z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M104 14a3 3 0 013 3v90a3 3 0 01-3 3H30a3 3 0 01-3-3V17a3 3 0 013-3h74zm0 2H30a1 1 0 00-.993.883L29 17v90a1 1 0 00.883.993L30 108h74a1 1 0 00.993-.883L105 107V17a1 1 0 00-.883-.993L104 16z"
            />
            <path fill={vars.white} d="M76 40h34a6 6 0 016 6v68a6 6 0 01-6 6H76a6 6 0 01-6-6V46a6 6 0 016-6z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M110 40a6 6 0 016 6v68a6 6 0 01-6 6H76a6 6 0 01-6-6V46a6 6 0 016-6h34zm0 2H76a4 4 0 00-3.995 3.8L72 46v68a4 4 0 003.8 3.995l.2.005h34a4 4 0 003.995-3.8l.005-.2V46a4 4 0 00-3.8-3.995L110 42z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M110 43a3 3 0 013 3v68a3 3 0 01-3 3H76a3 3 0 01-3-3V46a3 3 0 013-3h34zm0 2H76a1 1 0 00-.993.883L75 46v68a1 1 0 00.883.993L76 115h34a1 1 0 00.993-.883L111 114V46a1 1 0 00-.883-.993L110 45z"
            />
            <path fill={vars.bdlBoxBlue05} d="M76 46h34v68H76z" />
            <path fill={vars.white} d="M95 59h28a9 9 0 010 18H95a9 9 0 010-18z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M123 59a9 9 0 010 18H95a9 9 0 010-18h28zm0 2H95a7 7 0 00-.24 13.996L95 75h28a7 7 0 00.24-13.996L123 61z"
            />
            <path fill={vars.white} d="M91 83h28a9 9 0 010 18H91a9 9 0 010-18z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M119 83a9 9 0 010 18H91a9 9 0 010-18h28zm0 2H91a7 7 0 00-.24 13.996L91 99h28a7 7 0 00.24-13.996L119 85z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M91 83a9 9 0 11-.001 18.001A9 9 0 0191 83zm0 10c-2.204 0-4.236 1.464-5.335 3.797A7.477 7.477 0 0090.975 99a7.475 7.475 0 005.346-2.241C95.22 94.445 93.196 93 91 93zm0-7a3 3 0 100 6 3 3 0 000-6zm32-27a9 9 0 11-.001 18.001A9 9 0 01123 59zm0 10c-2.204 0-4.236 1.464-5.335 3.797a7.477 7.477 0 005.31 2.203 7.475 7.475 0 005.346-2.241C127.22 70.445 125.196 69 123 69zm0-7a3 3 0 100 6 3 3 0 000-6z"
            />
            <path fill={vars.white} d="M46 4h42a6 6 0 016 6v16a6 6 0 01-6 6H46a6 6 0 01-6-6V10a6 6 0 016-6z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M88 4a6 6 0 016 6v16a6 6 0 01-6 6H46a6 6 0 01-6-6V10a6 6 0 016-6h42zm0 2H46a4 4 0 00-3.995 3.8L42 10v16a4 4 0 003.8 3.995L46 30h42a4 4 0 003.995-3.8L92 26V10a4 4 0 00-3.8-3.995L88 6z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M49.217 20.004L52 22.786l-3.343 1.164c-.511.178-.778-.102-.604-.604l1.164-3.342zm11.783 2a1 1 0 110 2h-5a1 1 0 010-2h5zm-1.382-9.373a2.13 2.13 0 01.142 2.883l-.141.154-6.524 6.423-3.085-3.036 6.524-6.423a2.197 2.197 0 013.084 0z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M36.515 44a6 6 0 014.242 1.757l10.486 10.486A6 6 0 0153 60.485V92a6 6 0 01-6 6H19a6 6 0 01-6-6V50a6 6 0 016-6h17.515z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M36.515 44a6 6 0 014.242 1.757l10.486 10.486A6 6 0 0153 60.485V92a6 6 0 01-6 6H19a6 6 0 01-6-6V50a6 6 0 016-6h17.515zm0 2H19a4 4 0 00-3.995 3.8L15 50v42a4 4 0 003.8 3.995L19 96h28a4 4 0 003.995-3.8L51 92V60.485c0-.985-.363-1.932-1.016-2.663l-.156-.165-10.485-10.485a3.999 3.999 0 00-2.602-1.166L36.515 46z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M40.515 40a6 6 0 014.242 1.757l10.486 10.486A6 6 0 0157 56.485V88a6 6 0 01-6 6H23a6 6 0 01-6-6V46a6 6 0 016-6h17.515z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M40.515 40a6 6 0 014.242 1.757l10.486 10.486A6 6 0 0157 56.485V88a6 6 0 01-6 6H23a6 6 0 01-6-6V46a6 6 0 016-6h17.515zm0 2H23a4 4 0 00-3.995 3.8L19 46v42a4 4 0 003.8 3.995L23 92h28a4 4 0 003.995-3.8L55 88V56.485c0-.985-.363-1.932-1.016-2.663l-.156-.165-10.485-10.485a3.999 3.999 0 00-2.602-1.166L40.515 42z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M48.002 84a1 1 0 010 2h-22a1 1 0 110-2h22zm0-4a1 1 0 010 2h-22a1 1 0 110-2h22zm0-4a1 1 0 010 2h-22a1 1 0 110-2h22zM32.385 61.362c.323-.468 1.09-.486 1.441-.034l4.802 6.173 2.333-3.158c.303-.41.957-.456 1.333-.117l.071.073 6.46 7.5c.426.494.024 1.201-.684 1.201H25.858c-.667 0-1.078-.638-.733-1.138zM40 58a2 2 0 11.001 3.999A2 2 0 0140 58z"
            />
            <circle cx={112} cy={92} r={2} fill={vars.bdlBoxBlue} />
            <circle cx={117} cy={92} r={1} fill={vars.bdlBoxBlue10} />
            <circle cx={107} cy={92} r={1} fill={vars.bdlBoxBlue10} />
            <circle cx={93} cy={49} r={2} fill={vars.white} />
            <circle cx={93} cy={49} r={1} fill={vars.bdlBoxBlue} />
            <path
                fill={vars.bdlBoxBlue}
                d="M109 69a1 1 0 010 2H99a1 1 0 010-2h10zm0-4a1 1 0 010 2H95a1 1 0 010-2h14z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M43 42v7a4.999 4.999 0 004.783 4.995L48 54h7v2h-7a7 7 0 01-6.996-6.76L41 49v-7h2zm35.003-28.908v2.242l-.015.001c-3.442.39-5.736 2.604-7.88 7.118-.488 1.027.779 1.998 1.725 1.323l.35-.247c2.419-1.683 4.183-2.445 5.706-2.701l.114-.018v2.093c0 .914 1.108 1.422 1.856.851l5.712-4.36a1.057 1.057 0 00.094-1.622l-5.712-5.45c-.72-.687-1.95-.2-1.95.77zM22.4 60.308a3.154 3.154 0 01.18 6.302l-.18.005H10.545a1 1 0 01-.116-1.993l.116-.007h11.857a1.154 1.154 0 00.126-2.301l-.126-.006H8.308a3.308 3.308 0 00-.188 6.61l.188.005h5.47a1 1 0 01.116 1.993l-.117.007h-5.47a5.308 5.308 0 01-.218-10.611l.219-.004H22.4zm-8.623-3.231a1 1 0 01.117 1.993l-.117.007H8.39a1 1 0 01-.117-1.993l.117-.007h5.388z"
            />
        </g>
    </AccessibleSVG>
);

export default BoxMobile140;
